import type { FC } from 'react';
import { Button, Flex, Select, Typography } from 'antd';
import { ReloadOutlined, SunOutlined } from '@ant-design/icons';
import type {
  DashboardPeriod,
  DashboardPeriodOption,
} from '~/app/hooks/dashboard/useDashboardPeriodOptions';

const { Title, Text } = Typography;

export interface DashboardHeaderProps {
  greeting: string;
  subtitle: string;
  period: DashboardPeriod;
  periodOptions: DashboardPeriodOption[];
  periodAriaLabel: string;
  refreshAriaLabel: string;
  refreshLoading?: boolean;
  onPeriodChange: (period: DashboardPeriod) => void;
  onRefresh: () => void;
}

export const DashboardHeader: FC<DashboardHeaderProps> = ({
  greeting,
  subtitle,
  period,
  periodOptions,
  periodAriaLabel,
  refreshAriaLabel,
  refreshLoading = false,
  onPeriodChange,
  onRefresh,
}) => {
  return (
    <Flex
      justify="space-between"
      align="flex-start"
      gap={16}
      wrap="wrap"
      className="om-dashboard-header"
    >
      <div>
        <Flex align="center" gap={10}>
          <SunOutlined className="om-dashboard-header__sun" aria-hidden />
          <Title level={2} className="ds-page-title" style={{ margin: 0 }}>
            {greeting}
          </Title>
        </Flex>
        <Text type="secondary" className="om-dashboard-header__subtitle">
          {subtitle}
        </Text>
      </div>
      <Flex
        align="center"
        gap={8}
        className="om-dashboard-header__meta"
        wrap="wrap"
      >
        <Select
          className="om-dashboard-period-select"
          popupClassName="om-dashboard-period-dropdown"
          value={period}
          options={periodOptions}
          onChange={onPeriodChange}
          aria-label={periodAriaLabel}
          popupMatchSelectWidth={false}
        />
        <Button
          type="default"
          className="om-dashboard-header__refresh"
          icon={<ReloadOutlined />}
          loading={refreshLoading}
          onClick={onRefresh}
          aria-label={refreshAriaLabel}
        />
      </Flex>
    </Flex>
  );
};
